import React, { useState } from 'react';
import { formatWorkshopMeetingLine } from '../../services/workshop2026Service';
import { Meeting } from '../../services/meetingService';
import { useLocale } from '../../context/LocaleContext';
import styles from '../../styles/workshop2026Page.module.css';

interface WorkshopZoomBlockProps {
  meeting: Meeting | null;
  zoomUrl?: string;
  locked?: boolean;
  sectionId?: string;
}

const WorkshopZoomBlock: React.FC<WorkshopZoomBlockProps> = ({
  meeting,
  zoomUrl,
  locked = false,
  sectionId,
}) => {
  const { t } = useLocale();
  const [copied, setCopied] = useState(false);
  const meetingLine = formatWorkshopMeetingLine(meeting);
  const url = (zoomUrl || meeting?.zoom_url || '').trim();

  const handleCopy = async () => {
    if (!url) return;
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      /* ignore */
    }
  };

  if (locked) {
    return (
      <section id={sectionId} className={styles.zoomBlockFeatured}>
        <h3 className={styles.sectionSubheading}>{t('workshop.2026.zoom.heading')}</h3>
        <p className={styles.zoomSchedule}>{meetingLine}</p>
        <p className={styles.helperText}>{t('workshop.2026.zoom.locked_helper')}</p>
      </section>
    );
  }

  return (
    <section id={sectionId} className={styles.zoomBlockFeatured}>
      <h3 className={styles.sectionSubheading}>{t('workshop.2026.zoom.heading')}</h3>
      <p className={styles.zoomSchedule}>{meetingLine}</p>
      {url ? (
        <>
          <div className={styles.zoomActions}>
            <a href={url} target="_blank" rel="noopener noreferrer" className={styles.primaryBtn}>
              {t('workshop.2026.zoom.open')}
            </a>
            <button type="button" className={styles.secondaryBtn} onClick={handleCopy}>
              {copied ? t('workshop.2026.zoom.copied') : t('workshop.2026.zoom.copy')}
            </button>
          </div>
          <p className={styles.helperText}>{t('workshop.2026.zoom.passphrase_hint')}</p>
        </>
      ) : (
        <p className={styles.zoomPlaceholder}>{t('workshop.2026.zoom.placeholder')}</p>
      )}
    </section>
  );
};

export default WorkshopZoomBlock;
